import { FC } from 'react';
import {
    resolveCollectionImageSrc,
    resolveCollectionVideoSrc,
} from '../../../../../utils/mds/resolveCollectionPreviewSrc';
import { useGridImageOptimizer } from '../../../../../utils/mds/useGridImageAlias';
import { pluralize } from '../../../../../utils/pluralize';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconImage } from '../../../../icon/IconImage';
import { Box } from '../../../../layout/Box';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { Image } from '../../../../media/Image';
import { MediaCover } from '../../../../media/MediaCover';
import { Typography } from '../../../../typography/Typography';
import { ListItem } from '../../styles';
import { CollectionListItemProps } from './types';

const LIST_ITEM_PREVIEW_SIZE = 48;

export const CollectionListItem: FC<CollectionListItemProps> = ({ collection, onClick }) => {
    const preview = collection.previewItems[0];
    const t = useTranslation();
    const { getCompactAlias } = useGridImageOptimizer();
    const imageAlias = getCompactAlias(LIST_ITEM_PREVIEW_SIZE);

    const publicStatusText = t(collection.isPublic ? 'Публичная' : 'Секретная');
    const numberOfPostText = pluralize(
        collection.numberOfPosts,
        '%d пост',
        '%d поста',
        '%d постов',
    );

    return (
        <ListItem
            p={1}
            role="button"
            onClick={onClick}
            dataTestId={DataTestId.COLLECTION_LIST_ITEM}
        >
            <MediaCover width={48} minWidth={48} height={48} borderRadius={1}>
                {preview?.type === 'image' && (
                    <Image {...resolveCollectionImageSrc(preview.media, imageAlias)} />
                )}
                {preview?.type === 'video' && preview.media[0]?.firstFrameUrl ? (
                    <Image
                        src={resolveCollectionVideoSrc(preview.media[0].firstFrameUrl, imageAlias)}
                    />
                ) : null}
                {!preview && <IconImage fill="var(--color-primary)" />}
            </MediaCover>
            <Box>
                <Typography variant="body" weight="medium">
                    {collection.displayName}
                </Typography>
                <Typography variant="caption" color="secondary">
                    {`${publicStatusText}・${numberOfPostText}`}
                </Typography>
            </Box>
        </ListItem>
    );
};
